import { render, staticRenderFns } from "./StepperNavItem.vue?vue&type=template&id=65de36b2&scoped=true&"
import script from "./StepperNavItem.vue?vue&type=script&lang=js&"
export * from "./StepperNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65de36b2",
  null
  
)

export default component.exports